import qs from 'qs';

export namespace PathBuilder {
  export type RequestParams = {
    params?: any | null;
    queryString?: any | null;
  };

  export const attachQueryString = (oldPath: string, queryString: any)
  : string => `${oldPath}?${qs.stringify(queryString, { indices: false })}`;

  export const replaceParams = (oldPath: string, params: any): string => {
    let newPath = oldPath;
    Object.keys(params).forEach((key) => {
      newPath = newPath!.replace(`:${key}`, `${params[key]}`);
    });
    return newPath;
  };

  export const buildPath = (oldPath: string, requestParams: RequestParams): string => {
    let newPath = oldPath;
    if (!!requestParams && typeof requestParams?.queryString !== 'undefined') {
      newPath = attachQueryString(oldPath, requestParams.queryString);
    }
    if (!!requestParams && typeof requestParams?.params !== 'undefined') {
      newPath = replaceParams(newPath, requestParams.params);
    }
    return newPath;
  };
}
